import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";

import { login } from "./api";

export interface User {
  isSupplier?: boolean;
  userName?: string;
  companyId?: string;
  auth: boolean;
  serviceState?: string;
}

export const useUser = () => {
  const [user, setUser] = useState<User | null>(null);
  const [cookies] = useCookies(['token']);

  useEffect(() => {
    if (new URLSearchParams(window.location.search).get('authError') === '403') {
      setUser({ auth: false });
      return;
    }
    const token = cookies['token'];
    if (!!token) {
      login()
        .then((data) => {
          setUser({ ...data, isSupplier: data.companyType !== '2', auth: true });
        })
        .catch((error) => {
          console.log(error);
          if (error === 401) {
            setUser(null);
            return;
          }
          setUser({ auth: false });
        });
    } else {
      setUser(null);
      window.location.assign('/auth/login-force');
    }
  }, [cookies]);

  return user;
};
